const EmptyStar = ({ fill = '#BABABA' }: { fill?: string }) => {
    return (
        <svg
            width="41"
            height="41"
            viewBox="0 0 41 41"
            fill={fill}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M17.5051 7.54708C18.5113 5.43841 21.5128 5.43841 22.5191 7.54708L25.6069 14.0182L32.7156 14.9553C35.032 15.2606 35.9595 18.1153 34.265 19.7238L29.0647 24.6603L30.3702 31.7105C30.7956 34.0079 28.3673 35.7722 26.3138 34.6577L20.0121 31.2374L13.7103 34.6577C11.6568 35.7722 9.22849 34.0079 9.6539 31.7105L10.9594 24.6603L5.75918 19.7238C4.06465 18.1153 4.99219 15.2606 7.30859 14.9553L14.4172 14.0182L17.5051 7.54708ZM20.0121 10.0334L17.2957 15.7259C16.8908 16.5745 16.084 17.1607 15.1518 17.2836L8.89848 18.1079L13.473 22.4503C14.155 23.0977 14.4631 24.0461 14.2919 24.9707L13.1435 31.1727L18.687 28.1639C19.5134 27.7154 20.5107 27.7154 21.3371 28.1639L26.8806 31.1727L25.7322 24.9707C25.561 24.0461 25.8692 23.0977 26.5511 22.4503L31.1257 18.1079L24.8724 17.2836C23.9401 17.1607 23.1333 16.5745 22.7284 15.7259L20.0121 10.0334Z"
                fill="#4A4A4A"
            />
        </svg>
    )
}

export default EmptyStar
